import React, { useEffect, useState, useMemo, useCallback } from 'react';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';
import FloatingBanner from './FloatingBanner';

export function ConsentForm({ color }) {
  const [decisionMade, setDecisionMade] = useState(true); // start with true to avoid flashing
  const cookies = useMemo(() => new Cookies(), []);

  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  const sendConsent = useCallback((consent) => {
    gtag('consent', 'default', consent);
  }, []);

  useEffect(() => {
    if (cookies.get('gdpr-compliance') !== undefined) {
      setDecisionMade(true);
    } else {
      setDecisionMade(false);
    }
  }, [cookies, setDecisionMade, sendConsent]);

  const handleDecision = (consent) => {
    cookies.set('gdpr-compliance', consent, {
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      path: '/',
      domain: '.socialnetgroup.com',
    });

    sendConsent(consent);
    setDecisionMade(true);
  };

  return decisionMade ? (
    <></>
  ) : (
    <FloatingBanner
      color={color}
      header='Consent Header'
      message='Consent message'
      acceptText='Yes'
      denyText='No'
      onAccept={handleDecision}
      onDeny={handleDecision}
    />
  );
}

ConsentForm.propTypes = {
  color: PropTypes.string.isRequired,
};

ConsentForm.defaultProps = {
  color: 'blue',
};
